import { FC } from 'react';

import { ConfirmationModal } from '../ConfirmationModal';

interface ModalDeleteTabProps {
  onCancel: () => void;
  onOk: () => void;
  open: boolean;
  title: string;
  description: string;
}

export const ModalDeleteTab: FC<ModalDeleteTabProps> = ({
  onCancel,
  onOk,
  open,
  title,
  description
}) => {
  return (
    <ConfirmationModal
      open={open}
      onCancel={onCancel}
      onConfirm={onOk}
      confirmButtonLabel='Eliminar'
      title={title}
      description={description}
    />
  );
};
